<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0">
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        Inventuren ansehen
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider" />
    <div class="contentWrapper ordersContent" ref="contentWrapper">
      <div class="lastArticlesWrapper mt-3">
        <v-row
          v-if="!isLoading && this.fetchedInventories.length > 0"
          class="articleCardRow"
        >
          <v-col
            cols="12"
            class="articleCardCol"
            v-for="(inventory, index) in this.fetchedInventories"
            :key="index"
          >
            <v-card
              class="articleCard"
              elevation="0"
              @click="goToInventory(inventory)"
            >
              <v-list-item>
                <v-container>
                  <v-row class="orderCard">
                    <v-col cols="12">
                      <b>Inventur: </b>
                      <span
                        >vom {{ dateParse(inventory.begins_at) }} bis
                        {{ dateParse(inventory.ends_at) }}</span
                      >
                    </v-col>

                    <v-col cols="12">
                      <b>Gesamtwert: </b>
                      <span
                        >{{
                          inventory.inventory.totalPrice | parsePrice2Digits
                        }}
                        €</span
                      >
                    </v-col>
                  </v-row>
                </v-container>

                <v-btn
                  class="test"
                  @click.stop="getPDF(inventory.id)"
                  :disabled="pdfExportPending"
                >
                  Download

                  <v-progress-circular
                    class="progress"
                    indeterminate
                    v-bind:size="20"
                    v-bind:width="2"
                    color="#4C4C4C"
                    style="margin-left: 10px;"
                    v-if="pdfExportPending === inventory.id"
                  ></v-progress-circular>
                </v-btn>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div class="bottomFiller" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import router from "@/router";
export default {
  name: "inventories",

  data() {
    return {
      isLoading: true,
      fetchedInventories: [],
      pdfExportPending: false
    };
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: "setHeaderVisibility"
    }),

    ...mapActions("inventory", {
      downloadPDF: "downloadPDF"
    }),

    goBack() {
      router.go(-1);
    },

    goToInventory(inventory) {
      let id = inventory.id;
      router.push({ name: "Inventur", params: { inventory: inventory, id } });
    },

    dateParse(val) {
      let year = val.substring(0, 4);
      let month = val.substring(5, 7);
      let day = val.substring(8, 10);

      return day + "." + month + "." + year;
    },

    getInventories() {
      axios.get("api/getAllInventories").then(res => {
        res.data.forEach(el => {
          if (el.finished) {
            this.fetchedInventories.push({
              id: el.id,
              begins_at: el.begins_at,
              ends_at: el.ends_at,
              inventory: JSON.parse(el.inventory_total)
            });
          }
        });
        this.isLoading = false;
      });
    },

    getPDF(id) {
      this.pdfExportPending = id;
      this.downloadPDF(id).then(() => {
        this.pdfExportPending = false
      });
    }
  },

  created() {
    this.setHeaderVisibility(false);
    this.getInventories();
  }
};
</script>

<style>
.test {
  background-color: red !important;
}
</style>
